import { useSelector } from 'react-redux'

import { getIsAuthenticated } from 'selectors/auth'

export function useScrollableBasket() {
  const isAuthenticated = useSelector(getIsAuthenticated)

  return isAuthenticated
}
